<template>
    <v-navigation-drawer 
      dark
      width="95px"
      height="100vh"
      permanent
    >
      <!-- <v-list-item class="px-2 grey"> -->

        <!-- <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn> -->
      <!-- </v-list-item> -->
      <v-list dense class="">
          <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
        <v-list-item
          link
          class="mt-14"
          to="/c/dashboard"
           v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon class="ml-3 white--text" large>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          </v-list-item>
              </template>
              <span>Dashboard</span>
        </v-tooltip>

        <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
          <v-list-item
          link
          class="mt-14"
           v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon class="ml-3 white--text" large>mdi-image</v-icon>
          </v-list-item-icon>
          </v-list-item>
           </template>
              <span>Posts</span>
        </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
          <v-list-item
          link
          to="/c/incident"
          class="mt-14"
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon class="ml-3 white--text" large>mdi-bank</v-icon>
          </v-list-item-icon>
          </v-list-item>
          </template>
              <span>Incident</span>
        </v-tooltip>

             <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
           <v-list-item
          link
          to="/"
          class="mt-14"
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-icon>
            <v-icon class="ml-3 white--text" large>mdi-power</v-icon>
          </v-list-item-icon>
          </v-list-item>
          </template>
              <span>Logout</span>
        </v-tooltip>
          
          <!-- <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content> -->
      </v-list>
    </v-navigation-drawer>
</template>

<script>
  export default {
    data () {
      return {
        drawer: false,
        items: [
          { title: 'Home', icon: 'mdi-home-city' },
          { title: 'My Account', icon: 'mdi-account' },
          { title: 'Users', icon: 'mdi-account-group-outline' },
        ],
       
      }
    },
  }
</script>